import { Box } from "@material-ui/core";
import useConditions from "../../../hooks/useConditions";
import { useField } from "react-final-form";

const TierBenefitFixedField = () => {
  const { getPaymentConditionId, loading, error } = useConditions();
  const {
    input: { onChange },
  } = useField("condition_id");
  const {
    input: { onChange: onChangeValue },
  } = useField("condition_value");
  if (loading) return null;
  if (error) return null;

  onChange(getPaymentConditionId());
  onChangeValue(0);
  return <Box></Box>;
};

export default TierBenefitFixedField;
